import { FuseRouteItemType } from '@fuse/utils/FuseUtils';
import { lazyRetry } from '@utils/lazyRetry';

const AppsApp = lazyRetry(() => import('./AppsApp'));

const Archive = lazyRetry(() => import('./archive/Archive'));
const ApplicationWorkspace = lazyRetry(() => import('./ApplicationWorkspace'));

/**
 * The E-Commerce app Routes.
 */
const AppsAppRoute: FuseRouteItemType = {
  path: 'apps/:id',
  element: <AppsApp />,
  children: [
    {
      path: '',
      element: <ApplicationWorkspace />
    },
    { path: 'views/:viewId', element: <ApplicationWorkspace /> },
    {
      path: 'archive',
      children: [
        {
          path: '',
          element: <Archive />
        }
      ]
    }
  ]
};

export default AppsAppRoute;
